export const queryKeys = {
  user: "user",
  mdaList: "mdaList",
  invoiceRequest: "invoiceRequest",
  onboardingList: "onboardingList",
};
